import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { EventTypes, NotificationEvent } from '@store';

// https://wiki.viessmann-climatesolutions.com/display/EWV/Response+model%3A+Event+entry
export const NOTIFICATION_MESSAGES: { [key in EventTypes]: string } = {
  [EventTypes.DEVICE_BMU_SERIAL_CHANGED]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.DEVICE_BMU_SERIAL_CHANGED',
  [EventTypes.DEVICE_BOILER_SERIAL_CHANGED]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.DEVICE_BOILER_SERIAL_CHANGED',
  [EventTypes.FIRMWARE_UPDATE_STATUS]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.FIRMWARE_UPDATE_STATUS',
  [EventTypes.POTA_UPDATE_STATUS]: '+INSTALLATIONS.INSTALLATION.EVENT_LOG.POTA_UPDATE.HEADER',
  [EventTypes.GATEWAY_ONLINE]: '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.GATEWAY_STATUS',
  [EventTypes.GATEWAY_RESET_COMMAND]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.GATEWAY_RESET_COMMAND',
  [EventTypes.INSTALLATION_ADDRESS_CHANGED]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.INSTALLATION_ADDRESS_CHANGED',
  [EventTypes.FEATURE_CHANGED]: '+INSTALLATIONS.INSTALLATION.EVENT_LOG.FEATURE_CHANGED.TITLE',
  [EventTypes.INVITATION_ACCEPTED]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.INVITATION_STATUS',
  [EventTypes.INVITATION_TERMINATED]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.INVITATION_STATUS',
  [EventTypes.SRC_STATUS_CHANGED]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.SRC_STATUS_CHANGED',
  [EventTypes.SNAPSHOT_RESTORE_STATUS_CHANGED]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.SNAPSHOT_RESTORE_STATUS_CHANGED',
  [EventTypes.GEOFENCING_ACTIVATION_CHANGED]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.GEOFENCING_ACTIVATION_CHANGED',
  [EventTypes.HEATING_ROD_RUN_TOO_LONG]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.E-HEATER_RUNTIME_CHECK',
  [EventTypes.VIFLEX]: '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.VIFLEX',
  [EventTypes.DYNAMIC_SAVING_TIPS_HEATINGCURVE_SAVINGS]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.DYNAMIC_SAVING_TIPS_TITLE',
  [EventTypes.SETBACK_DURATION_CAN_BE_INCREASED_BY_ONE_HOUR]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.DYNAMIC_SAVING_TIPS_TITLE',
  [EventTypes.DHW_TARGET_TEMPERATURE_CAN_BE_DECREASED]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.DYNAMIC_SAVING_TIPS_TITLE',
  [EventTypes.DHW_DURATION_CAN_BE_DECREASED]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.DYNAMIC_SAVING_TIPS_TITLE',
  [EventTypes.EXTERNAL_LOCK]: '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.EXTERNAL_LOCK',
  [EventTypes.EXTERNAL_DEMAND]:
    '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.EXTERNAL_DEMAND',
} as { [key in EventTypes]: string };

@Injectable({
  providedIn: 'root',
})
export class EventsService {
  notificationMessages = NOTIFICATION_MESSAGES;

  constructor(private translation: TranslateService) {}

  getNotificationMessage(event: NotificationEvent): string {
    let translation = this.translation.instant(this.getNotificationTranslationKey(event));

    return translation;
  }

  getNotificationTranslationKey(event: NotificationEvent): string {
    return (
      this.notificationMessages[event.eventType] ||
      '+INSTALLATIONS.INSTALLATION.EVENT_LOG.NOTIFICATION.INSTALLATION_STATE_CHANGED'
    );
  }
}
